"use strict";

/*
This service is responsible for logging users out of the site when they've been inactive for too long.  Prior to being auto-logged-out, they are
given a warning message which tells them that they will soon be logged-out.  Activity is recorded in the form of clicks and keydowns.  When either of these
events happen, the time of the event is recorded in local storage where all tabs for the session can access it.  This values is stored here because it needs to
be accessible for all tabs.  Writing to the local storage causes an event to be fired in other tabs - which use the event to refresh their local copy of the value
(for performance reasons).  Within each tab, there's a polling loop which is trigged once per second.  It checks to see if it is time to show the 
warning dialog or if it is time to log the user out of the application.  

There is another timer which sends the server an ajax heartbeat as long as the user is active.  This is how the client and server stay in sync.

There is also logic in here which sync's the logged-in status across all tabs.  Both log-ins and logouts are performed via postback.  Upon re-loading the site and script, 
write the logged-in status of the current tab to the local storage.  Other tabs will receive the value via the local storage event and compare this value to their own 
status.  If it's changed, then the tab responds by redirecting to the appropriate page (either logout of the default provider page).
*/
angular.module('PatientApp').service('AutoLogoutService', function (VuexStore) {
  return {
    start: function start(enabled) {
      VuexStore.dispatch('startAutoLogout', enabled);
    }
  };
});